import template from './student-attention.html'

export let studentAttention = {
  bindings: {
    details: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['Validations', '$stateParams', 'GlobalSrv', '$scope', '$rootScope',
  function studentAttentionCtrl (Validations, $stateParams, GlobalSrv, $scope, $rootScope) {
    const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage

    //let inReviewExecution = Validations.inReviewExecution(currentStage)
    let inEvaluation = Validations.inEvaluation(currentStage)
    let columns = inEvaluation ? 'col-md-2' : 'col-md-3'

    angular.extend(this, {
      activity: {},
      watchEntries: inEvaluation,
      headingCSS: [columns, 'no-padding', 'text-center', 'font-normal', 'text-sm'], 
      contentCSS: [columns, 'no-padding', 'text-center', 'font-normal', 'text-sm', 'text-azul'], 
      inPerson: (activity) => { return activity.scheduleTypeId === 1 }
    })

    GlobalSrv.subscribe($scope, $rootScope, 'hoursChanged', (hours) => {
      this.details.hoursExecuted = hours
    })
  }
]}




// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/student-attention.js